module.exports = __webpack_public_path__ + "assets/img/warrior-name-234dd2f8.png";